import { absoluteUrl } from "../seo/siteUrl";

/**
 * Service schema for the main Production hub page.
 */
export function buildProductionServiceGraph() {
  const bizId = `${absoluteUrl("/")}#business`;
  const pageUrl = absoluteUrl("/production");

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        "@id": `${pageUrl}#production-service`,
        name: "Event production — stage, AV, décor, and logistics",
        description:
          "End-to-end event production including stage and truss, sound, LED, lighting, décor, catering coordination, artist management, and on-ground technical support for clients in Ahmedabad, Gujarat, and India.",
        url: pageUrl,
        serviceType: "Event production",
        provider: { "@id": bizId },
        areaServed: [
          { "@type": "City", name: "Ahmedabad" },
          { "@type": "AdministrativeArea", name: "Gujarat" },
          { "@type": "Country", name: "India" },
        ],
      },
      {
        "@type": "Event",
        "@id": `${pageUrl}#production-event-focus`,
        name: "Event production services — Ahmedabad & Gujarat",
        description:
          "Technical and creative production for weddings, corporates, and concerts with professional crews and equipment.",
        eventAttendanceMode:
          "https://schema.org/OfflineEventAttendanceMode",
        location: {
          "@type": "Place",
          name: "Panthi Events — Ahmedabad",
          address: {
            "@type": "PostalAddress",
            streetAddress:
              "A-107, Krish Elite, Beside HP Petrol Pump, Nr Vishal Land Mark, B/H Sankalp School, Sardar Patel Ring Rd, Nikol",
            addressLocality: "Ahmedabad",
            addressRegion: "Gujarat",
            postalCode: "382350",
            addressCountry: "IN",
          },
        },
        organizer: { "@id": bizId },
        offers: {
          "@type": "Offer",
          url: pageUrl,
          availability: "https://schema.org/InStock",
          price: "0",
          priceCurrency: "INR",
          description: "Production consultation — request a detailed quote",
        },
      },
    ],
  };
}
